import http from "../../http";

const pushTask = {
    selectMessageTask(param) {
        return http.spin.get("/gateway/api/lfuser/messageTask/selectMessageTask", param)
    },
    saveMessageTask(param) {
        return http.confirm.payload("/gateway/api/lfuser/messageTask/saveMessageTask", param)
    },
    deleteMessageTask(param) {
        return http.confirm.tip.post("/gateway/api/lfuser/messageTask/deleteMessageTask", param)
    },
    selectMessageTaskById(param) {
        return http.spin.get("/gateway/api/lfuser/messageTask/selectMessageTaskById", param)
    },
}
export default pushTask
